import React from 'react';
import { Phone, MapPin } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          <div>
            <img 
              src="https://i0.wp.com/bianhi.com/wp-content/uploads/2025/02/logo.png?fit=1698%2C721&ssl=1" 
              alt="Bianhi Medical Hair Restoration" 
              className="h-12 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-slate-400 leading-relaxed">{t('footer.description')}</p>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {t('footer.services')}
            </h4>
            <ul className="space-y-3 text-slate-400">
              <li><a href="#servicios" className="hover:text-[#14B8A6] transition-colors">{t('serviceOptions.trasplante-capilar')}</a></li>
              <li><a href="#servicios" className="hover:text-[#14B8A6] transition-colors">{t('serviceOptions.injerto-barba')}</a></li>
              <li><a href="#servicios" className="hover:text-[#14B8A6] transition-colors">{t('serviceOptions.injerto-mujeres')}</a></li>
              <li><a href="#servicios" className="hover:text-[#14B8A6] transition-colors">{t('serviceOptions.injerto-cejas')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-6" style={{ fontFamily: 'Manrope, sans-serif' }}>
              {t('footer.contact')}
            </h4>
            <ul className="space-y-4 text-slate-400">
              <li className="flex items-center gap-3">
                <Phone className="w-5 h-5 text-[#14B8A6]" />
                <a href="tel:+526645142275" className="hover:text-[#14B8A6] transition-colors">+52 (664) 514 2275</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#14B8A6] flex-shrink-0 mt-0.5" />
                <span>Av. Diego Rivera 2386, 5to Piso Suite 503,<br />Zona Urbana Rio, Tijuana, B.C.</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.facebook.com/bianhitj" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#009d9f] transition-colors" data-testid="social-facebook">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/bianhi.trasplantecapilarfue/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-[#009d9f] transition-colors" data-testid="social-instagram">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 text-center text-slate-500 text-sm">
          <p>&copy; {currentYear} Bianhi Medical Hair Restoration. {t('footer.rights')} Made with &#10084; by Mashaka.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
